module.exports = __webpack_public_path__ + "static/media/CO2_OUTOFRANGE.6dd9d08d.png";